// jurisdictionUtils.ts

import {
    doesCurrentTaxYearMatchCurrentYear,
    getCurrentTaxYear,
    sortAssessmentList,
} from "../../../../helpers/utils/Utils";
import {dummyAssessmentList} from "../../nationalEditor/TaxCertificate/TaxDetailTabSection";

interface Jurisdiction {
    jurisdictionId: string;
    collectorName: string;
    jurisdictionName: string;
    collectorId: string;
    tax_rate: string;
    bill_year: string;
    baseDue: string;
    baseTax: number | null;
    currentMonthDue: number | null;
    nextMonthDue: number | null;
    collectorAccountNumber: string;
    nonCollecting: boolean;
    inActive: boolean;
    tax_rate_List: any[];
    taxDataSource: any | null;
    asOfDate: Date | null;
    placeHolder: boolean;
}

interface AccountNote {
    relationalId: string;
    note: string;
}

interface SummaryItem {
    collector: string;
    collectorAccountNumber: string;
    taxYear: string;
    baseTaxDue: number | null;
    baseTax: number | null;
    currentMonthDue: number | null;
    nextMonthTaxDue: number | null;
    asOfDate: Date | null;
}

interface Bond {
    jurisdictionName: string;
    jurisdictionId: string;
    bondsApproved: number | null;
    bondsIssued: number | null;
    standbyFee: number | null;
}

interface Account {
    jurisdictionList: Jurisdiction[];
    bondList: Bond[];
    accountNotes: AccountNote[];
    summaryList: SummaryItem[];
    taxRateTotal: number | null;
    cadInformation: any[];
    baseTaxTotal: number | null;
    baseTaxDueTotal: number | null;
    currentMonthTotal: number | null;
    nextMonthTotal: number | null;
    assessments?: any[];
}
export const setTaskList = (
    taskList: any,
    setVendorTaskList: any,
    properties?:any
) => {
    if (!properties) {
        setVendorTaskList(taskList);
        return;
    }

    const updatedTaskList = taskList.map((curTask:any) => {
        if (!curTask.args) {
            return curTask;
        }

        const matchedProperty = properties?.find((prop:any) => prop?.id === curTask.args?.propertyId);
        return {
            ...curTask,
            args: {
                ...curTask.args,
                property: matchedProperty || null,
            },
        };
    });

    setVendorTaskList(updatedTaskList);
};


export function getUniqueFeeListAndNote(
    el: any,
    feeList: any,
    notes: any,
    certificateFees: any,
    certificateNotes: any,
    setIsSavedResult: any,
): void {


    let noteList : any = [];

    certificateFees.forEach((f:any) => {

        let isFeeListHaveNotNullValue = Object.values(f).every(value => {
            return !(value !== null && value !== '' && value !== false && value !== true);
        });

        if (!isFeeListHaveNotNullValue && !f.associationFee) {
            feeList.push(f);
        }

    });

    if (el.fees != null && el.fees.length > 0) {

        el.fees.forEach((fl: any) => {

            const found = feeList.find((obj:any) => {
                return obj.type === fl.feeType && obj.amount === fl.feeAmount && obj.periodStart === fl.assessmentPeriodStart && obj.periodEnd === fl.assessmentPeriodEnd && obj.frequency === fl.frequency &&
                    obj.note === fl.note;
            });

            if (!found) {
                feeList.push({
                    "type": fl.feeType,
                    "amount": fl.feeAmount,
                    "balance": fl.feeAmount,
                    "periodStart": fl.assessmentPeriodStart,
                    "periodEnd": fl.assessmentPeriodEnd,
                    "frequency": fl.frequency,
                    "note": fl.note,
                    "associationFee": true
                });
                setIsSavedResult(false);
            }
        });
    } else {
        if (feeList.length > 0) {
            feeList = feeList.filter((el:any) => el.associationFee === true);
        }
    }

    certificateNotes.forEach((nl:any) => {
        if (nl.comment !== "Voluntary HOA") {
            noteList.push({
                comment: nl.comment,
                associationNote: nl.associationNote,
                redColor: nl.redColor,
                yellowHighlight: nl.yellowHighlight,
                bold: nl.bold,
                saveAsCanned: nl.saveAsCanned
            })
        }
    });

    if (el.certificateNotes != null && el.certificateNotes.length > 0) {
        el.certificateNotes.forEach((n:any) => {

            const found = noteList.find((obj:any) => {
                return obj.comment === n.comment;
            });

            if (!found && n.visible === true) {
                noteList.push({
                    comment: n.comment,
                    associationNote: true,
                    redColor: n.redColor,
                    yellowHighlight: n.yellowHighlight,
                    bold: n.bold,
                    saveAsCanned: n.saveAsCanned
                });
                setIsSavedResult(false);
            }

        });
    } else {
        if (noteList.length > 0) {
            noteList = noteList.filter((el:any) => el.associationNote === true);
        }
    }

    if (feeList.length === 0) {
        feeList.push({
            "type": "",
            "amount": null,
            "balance": null,
            "periodStart": null,
            "periodEnd": null,
            "frequency": "",
            "note": "",
            "associationFee": false
        });
    }

    if (el.voluntary === true) {
        const found = noteList.find((obj:any) => {
            return obj.comment === "Voluntary HOA";
        });
        if (!found) {
            noteList.push({
                comment: "Voluntary HOA",
                associationNote: true
            });
        }
    }

    if (noteList.length > 0) {
        noteList.forEach((kl:any) => {
            if (!(el.certificateNotes != null && el.certificateNotes.length > 0 && el.certificateNotes.some((pl:any) => pl.noteBody === kl.comment && pl.visible === false))) {
                notes.push(kl);
            }
        });
    }
}


export function PopulateHoaInfo(
    associationName: any,
    managementCompanyName: any,
    managementCompanyId: any,
    email: any,
    phone: any,
    mailingAddress: any,
    zipCode: any,
    city: any,
    state: any,
    contactName: any,
    el: { [key: string]: any },
    website: any,
    thirdPartyProviderId: any,
    thirdPartyProviderName: any,
    updatedAccount?:any
) {

    const updatedAddress = {
        mailingAddress,
        zipCode,
        city,
        state,
    };

    const updatedManagementCompany = {
        name: managementCompanyName,
        managementCompanyId,
        email,
        phone,
        contactName,
        website,
        address: updatedAddress,
    };

    return {
        ...updatedAccount,
        associationName: el.name,
        managementCompany: updatedManagementCompany,
        thirdPartyProviderId,
        thirdPartyProviderName,
    };

}


export function removeDuplicateAndNegativeItems(arr:any) {
    arr = arr.filter(function (x:any) {
        return x > -1
    });
    return [...new Set(arr)];
}

export function checkProperties(obj: any): boolean {
    for (let key in obj) {
        if (key !== "address" && obj[key] !== null && obj[key] !== "") {
            return true;
        } else if (key === "address" && obj[key] !== null && obj[key] !== "") {
            return checkProperties(obj[key]);
        }
    }
    return false;
}
export const formatPhone = (input:any) => {

    if (!input) {
        return "";
    }
    // Remove non-numeric characters from input
    const cleaned = ('' + input).replace(/\D/g, '');

    // Format the phone number (###) ###-####
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return input;
};

export function alphabeticalOrder(arr : any) {
    return arr.sort((a : any, b : any) => a < b ? -1 : 1)
}
export function getAssessmentList(certificate: any, i: any) {
    let account = certificate.accounts[i];

    if (account?.assessments?.length === 0) {
        return dummyAssessmentList();
    }

    // Filter out invalid assessments
    let assessments = account.assessments;
    if (assessments.length === 0) {
        return dummyAssessmentList();
    }
    // Sort the highest years first, so we grab the years we want
    assessments = sortAssessmentList(assessments, ['taxYear'], ['desc'])

    let outputAssessments = [];

    if (assessments.length > 1) {
        outputAssessments.push(assessments[0]);
        outputAssessments.push(assessments[1]);
    } else {
        let currentTaxYear = getCurrentTaxYear();
        let hasCurrentAssessment = assessments[0]?.taxYear && assessments[0].taxYear === currentTaxYear;

        let desiredYear = doesCurrentTaxYearMatchCurrentYear() ? currentTaxYear + 1 : currentTaxYear - 1;

        let assessment = {
            "taxYear": hasCurrentAssessment ? desiredYear : getCurrentTaxYear(),
            "improvementMarketValue": null,
            "landMarketValue": null,
            "agMarketValue": null,
            "overrideAppraisedValue": null,
            "overrideAssessedValue": null,
            "agTimberValue": null,
            "agLossValue": null,
            "homesteadCapValue": 0,
            "exemptions": [],
            "assessedValue": null,
            "agriculturalValue": null,
            "landTotalValue": null,
            "overrideAgValue": null,
            "appraisedValue": null,
            "certified": !!hasCurrentAssessment,
            "overrideLandTotalValue": null,
            "woExemptionAmount": null,
            "overrideWoExemptionAmount": null,
            "withExemptionEstimate": null,
            "withExemptionEstimateOverride": null,
        };

        outputAssessments.push(assessments[0]);
        outputAssessments.push(assessment);
    }
    // Sort the lowest years first, so we order our two records correctly
    return sortAssessmentList(outputAssessments, ['taxYear'], ['asc']);
}

